import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {useEffect, useState} from 'react';

import {Tab, TabContainer} from 'ui-library/TabContainer';

import {NodeDetailsSidepanelContentProps, SidepanelTab} from '../processFlowchartConfigEditorConstants';

export default function NodeDetailsSidepanelContent(props: {
  nodeDetailsSidepanelContentProps: NodeDetailsSidepanelContentProps;
  tabs: Array<SidepanelTab>;
}): JSX.Element {
  const {nodeDetailsSidepanelContentProps, tabs} = props;
  const defaultTabKey = tabs[0].key;
  const nodeFieldDetailsTab = tabs.find((tab) => tab.openOnFieldSelect);

  const [activeTab, setActiveTab] = useState<string>(
    nodeDetailsSidepanelContentProps.selectedFieldId
      ? (nodeFieldDetailsTab?.key ?? defaultTabKey)
      : defaultTabKey
  );

  useEffect(() => {
    const newActiveTab = nodeDetailsSidepanelContentProps.selectedFieldId
      ? (nodeFieldDetailsTab?.key ?? defaultTabKey)
      : defaultTabKey;
    setActiveTab(newActiveTab);
  }, [nodeDetailsSidepanelContentProps.selectedFieldId, nodeFieldDetailsTab?.key, defaultTabKey]);

  return (
    <TabContainer<string>
      activeTab={activeTab}
      onRequestTabChange={setActiveTab}
      className={classNames(css(styles.sidepanelTabContainerStyle))}
      headerDividerClassName={css(styles.sidepanelHeaderDividerStyle)}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.key}
          title={<div className={css(styles.tabTitleStyle)}>{tab.label}</div>}
          tabKey={tab.key}
        >
          <tab.content {...nodeDetailsSidepanelContentProps} />
        </Tab>
      ))}
    </TabContainer>
  );
}

const styles = StyleSheet.create({
  tabContentContainer: {
    padding: '16px',
    marginTop: '-23px',
  },
  tabTitleStyle: {
    display: 'flex',
    fontSize: '12px',
    paddingTop: '12px',
    paddingBottom: '6px',
    marginLeft: '12px',
    marginRight: '12px',
  },
  sidepanelTabContainerStyle: {
    marginTop: '-4px',
  },
  sidepanelHeaderDividerStyle: {
    borderTop: `1px solid ${Color.GRAY_300}`,
  },
  noFieldSelectedText: {
    fontSize: '16px',
    color: Color.GRAY_900,
  },
});
